<template>
  <v-layout>
    <div class="padding-container-sm">
      <div class="header">
        <span slot="header">
          <div class="row">
            <div class="col col-md-12 p-5 progress-view">
              <v-tab :tabProps="tabProps" v-on:activeTab="activeTab">
                <div slot="intervention">
                  <Interventions />
                </div>
                <div slot="assessment" v-if="this.tabProps.activeTabName === 'Side Effects/Symptoms'">
                  <Observation />
                </div>
                <div slot="reminders" v-if="this.tabProps.activeTabName === 'Reminders'">
                  <Reminders />
                </div>
              </v-tab>
            </div>
          </div>
        </span>
      </div>
    </div>
  </v-layout>
</template>

<script>
import VLayout from "@/layouts/Default.vue";
import VTab from "@/components/tab/tab.vue";
import Observation from "@/components/assessment/observation.vue";
import Reminders from "@/components/assessment/reminders.vue";
import Interventions from "@/components/assessment/interventions.vue";
import { mapGetters } from "vuex";

export default {
  name: "PatientList",
  components: {
    VLayout,
    VTab,
    Interventions,
    Observation,
    Reminders
  },

  data() {
    return {
      tabProps: {
        tabs: [],
        activeTabName: null,
        currentUser: this.currentUser
      },
      allTabs : [
      {
        title: "Prescription",
        slot: "intervention"
      },
      {
        title: "Side Effects/Symptoms",
        slot: "assessment"
      },
      {
        title: "Reminders",
        slot: "reminders"
      }
    ],
     remindersTab : [
        {
          title: "Reminders",
          slot: "reminders"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/getUser"
    }),
  },
  watch: {
    currentUser: {
       immediate: true,
       handler: 'onCurrentUserChange'
    }
  },
  methods: {
    activeTab(name) {
      this.tabProps.activeTabName = name;
    },
    onCurrentUserChange() {
      if (this.currentUser) {
          this.tabProps.tabs = this.currentUser.designation === 'CARE_NAVIGATOR' ? this.allTabs : this.remindersTab;
          this.tabProps.activeTabName = this.tabProps.tabs[0].title;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
